import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../../../../types/upload-field'
import RatingField from '../../../../../form-fields/upload/rating'
import { CreationCaptureInfoContext } from '../manager'

const Rating = styled(RatingField)`
    grid-column: span 2;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationCaptureInfoRatingField = ({ className, field }: Props) => {
    const { rating, setRating } = useContext(CreationCaptureInfoContext)

    return (
        <Rating
            {...{
                className,
                field,
                defaultRating: rating,
                showInstructions: true,
                onChange: setRating,
            }}
        />
    )
}

export default CreationCaptureInfoRatingField
